<template>
  <div class="calculator-menu" :style="customStyle" v-if="Object.keys(getMenu).length > 0">
    <div class="container">
      <div class="row">
        <div class="left col-sm-7 col-md-6" v-if="isLoggedOut">
          <QIcon class="mobile-icon" @click="toggleMobileMenu" :name="mobileIcon" :size="'25px'" />
          <ul class="menu-ul">
            <li v-for="(value, key) of getMenu" :key="key">
              <a :href="value.menuUrl">{{ value.menuTitle }}</a>
            </li>
          </ul>
        </div>
        <div :class="isLoggedOut ? 'col-sm-5 col-md-6' : 'col-12'">
          <div class="left-menu">
            <a :href="`tel:${getPhoneNumber}`" class="phone">
              <Phone size="15px" /><span>{{ getPhoneNumber }}</span>
            </a>
            <QBtn class="login-button q-no-shadow" outline :rounded="getIsCalculatorButtonRounded" @click="handleLogin" no-caps>{{
              btnText
            }}</QBtn>
          </div>
        </div>
      </div>
      <div :class="{ 'mobile-menu': true, 'open': isMobileOpen }">
        <ul class="menu-ul">
          <li v-for="(value, key) of getMenu" :key="key">
            <a :href="value.menuUrl">{{ value.menuTitle }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { QBtn, QIcon } from 'quasar';
import { mapGetters } from 'vuex';
import Phone from '../Icon/Phone';
import { evaClose, evaMenu2Outline } from '@quasar/extras/eva-icons';
export default {
  name: 'CalculatorMenu',
  data() {
    return {
      isMobileOpen: false,
      mobileIcon: evaMenu2Outline,
      customStyle: {
        backgroundColor: '#002856'
      },
      organisationLogoPlaceholder: `${process.env.BASE_URL}assets/logos/fleetpartners_logo.svg`,
      fleetPartnerLogoPlaceholder: `${process.env.BASE_URL}assets/logos/fleetpartners_logo.svg`
    };
  },
  computed: {
    ...mapGetters({
      calculator: 'theme/getCalculator',
      scoreboard: 'theme/getScoreboard',
      getIsCalculatorButtonRounded: 'theme/getIsCalculatorButtonRounded'
    }),
    getMenu() {
      if (this.calculator === undefined || this.calculator.headerLinks === undefined) {
        return [];
      }
      return this.calculator.headerLinks;
    },
    getPhoneNumber() {
      return this.scoreboard?.phoneNumber ? this.scoreboard.phoneNumber : '';
    },
    btnText() {
      return this.isLoggedOut ? 'Customer login' : 'Logout';
    }
  },
  created() {
    this.isLoggedOut = !this.$auth.isAuthenticated;
    if (this.calculator?.headerColour) {
      this.customStyle.backgroundColor = this.calculator.headerColour;
    }
  },
  methods: {
    toggleMobileMenu() {
      this.isMobileOpen = !this.isMobileOpen;
      this.mobileIcon = this.isMobileOpen ? evaClose : evaMenu2Outline;
    },
    handleLogin() {
      if (this.isLoggedOut) {
        this.$router.push({ name: 'login' });
        return;
      }
      this.$router.push({ name: 'logout' });
    }
  },
  components: { QBtn, QIcon, Phone }
};
</script>

<style lang="sass" scoped>
.calculator-menu
  padding-top: 12px
  padding-bottom: 12px
  a
    color: #fff
  button.q-btn .q-btn__wrapper
    padding: 5px 40px
    &:before
      box-shadow: none
  .container
    max-width: 1440px
    padding-left: 10px
    padding-right: 10px
  .row
    align-items: center
  .left
    flex: 1 1 auto
    > ul
      display: none
  .menu-ul
    row-gap: 15px
    flex-wrap: wrap
    list-style: none
    column-gap: 15px
    margin-top: 0
    margin-bottom: 0
    height: 100%
    align-items: center
    flex-direction: column
    align-items: flex-start
    padding-left: 0
    li > a
      color: #fff
      font-size: 15px

  .mobile-menu
    display: none
    border-top: 1px solid #fff
    margin-top: 10px
    padding-top: 10px
    animation: fadeIn 0.5s ease-in-out forwards;
    &.open
      display: block
    ul
      display: grid
      row-gap: 10px
  .left-menu
    display: flex
    align-items: center
    gap: 20px
    justify-content: flex-end
    .phone
      font-weight: bold

@keyframes fadeIn
  from
    opacity: 0
  to
    opacity: 1


@media (min-width:900px)
  .calculator-menu
    .mobile-icon
      display: none
    .left > ul
      display: flex
    .menu-ul
      display: flex
      flex-direction: row
    .mobile-menu
      display: none
</style>
